module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-hotel.68c6d4dc.jpg";